(function () {
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  function initDoor(frame) {
    if (frame._ready) return; frame._ready = true;
    var wrap = frame.closest('.room33-door') || frame.parentElement;
    var panels = frame.querySelectorAll('[data-panel]');
    var reveal = frame.querySelector('[data-reveal]');
    var toggle = wrap.querySelector('[data-door-toggle]');
    var revealed = wrap.querySelector('[data-door-revealed]');
    var headline = wrap.querySelector('[data-door-headline]');
    var open = false;
    function setOpen(v) {
      if (open === v) return; open = v; var sw = reduce ? 0 : 105;
      panels.forEach(function (p) { var dir = p.getAttribute('data-panel') === 'left' ? -sw : sw; p.style.transform = v ? 'rotateY(' + dir + 'deg)' : 'rotateY(0deg)'; });
      if (reveal) { reveal.style.opacity = v ? '1' : '0'; reveal.style.pointerEvents = v ? 'auto' : 'none'; }
      if (toggle) toggle.style.display = v ? 'none' : 'inline-block';
      if (revealed) revealed.style.display = v ? 'flex' : 'none';
      if (headline) { var t = v ? headline.getAttribute('data-open') : headline.getAttribute('data-closed'); if (t) headline.textContent = t; }
    }
    panels.forEach(function (p) { p.addEventListener('click', function () { setOpen(true); }); });
    if (toggle) toggle.addEventListener('click', function () { setOpen(true); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { setTimeout(function () { setOpen(true); }, 600); io.disconnect(); } }); }, { threshold: 0.6 });
      io.observe(frame);
    } else setTimeout(function () { setOpen(true); }, 600);
  }
  function scan(root) { (root || document).querySelectorAll('[data-door]').forEach(initDoor); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', function () { scan(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
